// extracted by mini-css-extract-plugin
module.exports = {"root":"XkiV3s8A","content":"pRcVpNC2","title":"ypBB9DYW","description":"cJoikJ6K","rightAccessory":"wMtjY0GD","leftAccessory":"mbDHZ1OC"};